<script lang="ts">
	//Helpers
	import { capFirstChar } from '../../helpers/utilities';
	import { batchUpdate, validateWiFiCredentials } from '../../helpers/batch_update_helpers';
	import { setWizardSteps } from '../Lists/list-helpers';
	//Services
	import { format } from 'svelte-i18n';
	//Stores
	import { resetEditUpdateStore, update } from 'src/stores/ui/edit_lists';
	//Components
	import WiFiChannelSelection from './Steps/WiFiChannelSelection.svelte';
	import WiFiCredentials from './Steps/WiFiCredentials.svelte';
	import WizardWrapperEditableObject from '../ModalWizzard/WizardWrapperEditableObject.svelte';
	import { saved_wifi_neworks } from 'src/stores/features/wifi/passwords';
	import type { ExtendEditableObject } from 'src/types/EditableObject';
	import { user_data } from 'src/stores/account/user';
	import { resetFiltersAllDevicesList } from 'src/stores/ui/filters';
	import { toast } from '@Shelly/shelly-design-system';

	export let showModal: boolean;
	export let areFiltersDisabled: boolean;

	let defaultWiFiObject = {
		enable: true,
		ssid: '',
		is_open: false,
		pass: '',
		ipv4mode: 'dhcp',
		ip: null,
		netmask: null,
		nameserver: null,
		gw: null,
		sta: 0,
		savePass: false,
	} as ExtendEditableObject;

	let WiFiConfig = defaultWiFiObject;

	const selectedDevices = $update.selectedDevices;

	$: disabled = !validateWiFiCredentials(WiFiConfig);

	const onCloseModal = () => {
		showModal = false;
	};

	let wizardComponents = [WiFiChannelSelection, WiFiCredentials];

	let wizardItems = setWizardSteps([
		capFirstChar(
			$format('title_select_wifi_channel', {
				default: 'Select Wi-Fi channel',
			}),
		),
		capFirstChar($format('button_connect_network')),
	]).map((item, ind) => {
		return { ...item, component: wizardComponents[ind] };
	});

	const onFinish = async () => {
		if (WiFiConfig.savePass) {
			saved_wifi_neworks.update($user_data.email, {
				ssid: WiFiConfig.ssid,
				pass: WiFiConfig.pass,
			});
		} else {
			if (
				$saved_wifi_neworks !== null &&
				$saved_wifi_neworks[$user_data?.email]?.[WiFiConfig.ssid]
			) {
				saved_wifi_neworks.remove($user_data.email);
			}
		}
		if (validateWiFiCredentials(WiFiConfig)) {
			await batchUpdate(selectedDevices, WiFiConfig);
			WiFiConfig = defaultWiFiObject;
			update.update((s) => {
				return {
					...s,
					selectedDevices: undefined,
				};
			});
			toast.open({
				type: 'success',
				title: $format('toast_success_wifi_settings', {
					default: 'Successfully applied Wi-Fi settings.',
				}),
			});
		} else {
			toast.open({
				type: 'danger',
				title: $format('setting_err_toast', {
					default: 'Failed to apply settings.',
				}),
			});
		}
		resetEditUpdateStore();
		resetFiltersAllDevicesList();
		areFiltersDisabled = false;
	};
</script>

<WizardWrapperEditableObject
	on:close={(e) => onCloseModal()}
	bind:showModal
	bind:editableObject={WiFiConfig}
	fromWifiBatch
	title={$format('wizard_modal_title_select_wifi', { default: 'Select Wi-Fi' })}
	bind:wizardItems
	{disabled}
	callback={onFinish}
/>
